import { axiosInstance } from "./AxiosDefaults";
import { Agenda } from "../models/Agenda";

export const getAllAgendas = (): Promise<any> => {
  return axiosInstance.get(
    //TODO: izmeniti da dobija agenda iz dogadjaja
    "/agendas",
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const getAgenda = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/agendas`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createAgenda = (agenda: Agenda): Promise<any> => {
  return axiosInstance.post("/agendas", agenda, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateAgenda = async (
  id: string,
  agenda: Agenda
): Promise<any> => {
  return axiosInstance.put(`${"/agendas"}/${id}`, agenda, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllParticipantInAgenda = (id: string): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get(`${`/agendas/all-participant`}/${id}`, {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};
